export const quotationsList = [
	{
		name: '系统介绍',
		comeFrom: '',
		content:'本平台专为小说创作者、分销商和管理者精心设计，旨在提供高效、便捷的管理体验。无论您是小说制作团队、分销商，还是内容管理人员，我们的后台管理平台都能为您提供一站式服务，助您轻松管理和分销小说内容。让我们共同打造一个精彩纷呈的小说世界！',
	},
	// {
	// 	name: '荀子',
	// 	comeFrom: '劝学',
	// 	content:
	// 		'木料经过木工用墨线（木工用具）划直线加工以后，就变直了；金属物品在磨刀石上磨砺后，就能锋利。人经过学习磨练，自我反省，就会变得聪慧明智，不犯错误，也越来越坚强。',
	// },
	// {
	// 	name: '里仁',
	// 	comeFrom: '论语',
	// 	content:
	// 		'见到贤人，就应该想着向他学习；看见不贤的人，便应该自己反省，对不如自己的人喜欢讥笑、轻视，因而沾沾自喜；对比自己强的人喜欢贬低，甚至嫉妒、畏惧退缩，害怕与他们交往：这都是不正确的态度。',
	// },
	// {
	// 	name: '述而',
	// 	comeFrom: '论语',
	// 	content:
	// 		'君子心地平坦宽广，小人却经常局促忧愁。君子襟怀坦白，安贫乐业，与人为善，知足常乐，所以能坦荡荡。小人欲念太多，患得患失，忧心忡忡，怨天尤人，局促不安，所以常心怀戚戚。',
	// },
	// {
	// 	name: '老子',
	// 	comeFrom: '第六十四章',
	// 	content:
	// 		'千里遥远的路程是从脚下第一步开始的。任何事情的成功都是从头开始，从小到大逐渐积累的。万事开头难，没有个开头就不会有结果。任何事情都要从一点一滴的小事开始做起。',
	// },
	// {
	// 	name: '朱熹',
	// 	comeFrom: '训学斋规',
	// 	content:
	// 		'读书有三到，谓心到，眼到，口到。心不在此，则眼看不仔细，心眼既不专一，却只漫浪诵读，决不能记，久也不能久也。三到之中，心到最急，心既到矣，眼口岂不到乎？',
	// },
];
